export default __webpack_public_path__ + "media/images/icons_fc/graphblanc-d57696a1a31bbb8b0998ad5e7a6da151.png";